export default __webpack_public_path__ + "static/2054-ffb92c7c5dbd44ece4e93b86cc0b9939.gif";